import { render, staticRenderFns } from "./AccountTypes.vue?vue&type=template&id=c64e363e&"
import script from "./AccountTypes.vue?vue&type=script&lang=js&"
export * from "./AccountTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports